import { useCallback } from 'react'
import { useMutation } from '@apollo/client'
import { SHARE_MENTION, UPDATE_MENTION } from 'apollo/mutations/mention'
import type { SendMentionEmailsInput } from 'apollo/generated/globalTypes'
import type {
  ShareMentionByEmail,
  ShareMentionByEmailVariables,
} from 'apollo/generated/ShareMentionByEmail'
import type {
  UpdateMention,
  UpdateMentionVariables,
} from 'apollo/generated/UpdateMention'

const useMentionActions = () => {
  const [shareMentionMutation, { loading: shareMentionIsLoading }] =
    useMutation<ShareMentionByEmail, ShareMentionByEmailVariables>(
      SHARE_MENTION,
    )

  const [updateMentionMutation, { loading: updateMentionIsLoading }] =
    useMutation<UpdateMention, UpdateMentionVariables>(UPDATE_MENTION, {
      refetchQueries: ['MentionsQuery'],
    })

  const shareMentionByEmail = useCallback(
    async ({ emails, comments, mention }: SendMentionEmailsInput) => {
      let username = mention.username
      let name = mention.name

      if (!username && name) {
        username = name
      }

      if (!name && username) {
        name = username
      }

      await shareMentionMutation({
        variables: {
          input: {
            emails,
            comments,
            mention: { ...mention, username, name },
          },
        },
      })
    },
    [shareMentionMutation],
  )

  const updateMention = useCallback(
    async (targets, input) => {
      await updateMentionMutation({
        variables: {
          targets,
          input,
        },
      })
    },
    [updateMentionMutation],
  )

  return {
    shareMentionByEmail,
    updateMention,
    mentionActionsLoading: shareMentionIsLoading || updateMentionIsLoading,
  }
}

export default useMentionActions
